import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Comment } from '../models/comment';
import { updateCommentEndpoint } from './const';

export const updateComment = (comment: Comment) => {
    return getHttpClient().post({ url: updateCommentEndpoint, data: JSON.stringify(comment) });
};
